import { fetch, fetchV1 } from 'helpers/fetch.js';

export default {
  getCurrentUser() {
    return fetch.get('/users/current').forceUpdate(true);
  },
  setUserEntity(id) {
    return fetchV1.post(`/entities/${id}/user_entity`);
  },
  switchAccount(account_id) {
    return fetch.post('/account', { account_id });
  },
};
